import Campaigns from './Service/Campaigns'
import Customers from './Service/Customers'
import PriceLists from './Service/PriceLists'
import Products from './Service/Products'
import RegionCustomerGroupPriceLists from './Service/RegionCustomerGroupPriceLists'
import RegionPriceLists from './Service/RegionPriceLists'
import RegionSupplierPriceLists from './Service/RegionSupplierPriceLists'
import StoreRegions from './Service/StoreRegions'
import Events from './Service/Events'

class Api {
  /**
   * @name Api#campaigns
   * @type {Campaigns}
   */

  /**
   * @name Api#customers
   * @type {Customers}
   */

  /**
   * @name Api#priceLists
   * @type {PriceLists}
   */

  /**
   * @name Api#products
   * @type {Products}
   */

  /**
   * @name Api#regionCustomerGroupPriceLists
   * @type {RegionCustomerGroupPriceLists}
   */

  /**
   * @name Api#regionPriceLists
   * @type {RegionPriceLists}
   */

  /**
   * @name Api#regionSupplierPriceLists
   * @type {RegionSupplierPriceLists}
   */

  /**
   * @name Api#storeRegions
   * @type {StoreRegions}
   */

  /**
   * @name Api#events
   * @type {Events}
   */

  /**
   * @param {Connection} connection
   */
  constructor (connection, cacheTimeNormal = 3600) {
    this.storeRegions = new StoreRegions(connection, cacheTimeNormal)
    this.customers = new Customers(connection, cacheTimeNormal)
    this.products = new Products(connection, cacheTimeNormal)

    this.campaigns = new Campaigns(connection, cacheTimeNormal)
    this.priceLists = new PriceLists(connection, this.productsInPriceList, cacheTimeNormal)
    this.events = new Events(connection, cacheTimeNormal)

    this.regionCustomerGroupPriceLists = new RegionCustomerGroupPriceLists(
      connection,
      this.storeRegions,
      this.priceLists,
      cacheTimeNormal
    )

    this.regionPriceLists = new RegionPriceLists(
      connection,
      this.storeRegions,
      this.priceLists,
      cacheTimeNormal
    )

    this.regionSupplierPriceLists = new RegionSupplierPriceLists(
      connection,
      cacheTimeNormal
    )
  }

  setEventBus (eventBus) {
    this.events.setEventBus(eventBus)
    this.campaigns.setEventBus(eventBus)
    this.customers.setEventBus(eventBus)
    this.priceLists.setEventBus(eventBus)
    this.products.setEventBus(eventBus)
    this.regionCustomerGroupPriceLists.setEventBus(eventBus)
    this.regionPriceLists.setEventBus(eventBus)
    this.regionSupplierPriceLists.setEventBus(eventBus)
    this.storeRegions.setEventBus(eventBus)
  }
}
export default Api



// WEBPACK FOOTER //
// ./src/api/Api.js